// import React, { Component } from 'react';
import styled from 'styled-components';

const Span = styled.div`
  visibility: hidden;
  background-color: #666;
  color: #fff;
  text-align: center;
  border-radius: 3px;
  padding: 2px 5px;
  position: absolute;
  z-index: 10000000;
  bottom: 0;
  left: 0;
  top: 100%;
  height: 20px;
  font-size: 0.8em;
  white-space:nowrap;
`

export default Span;



// WEBPACK FOOTER //
// ./src/_Tooltip.js